// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 583) return "static/chunks/583-cb48105be2c769c2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"939":"cb7832df37ce81db","976":"0e950ff1eb28998d"}[chunkId] + ".js";
};